{
  "$schema": "../extension_schema.json",
  "name": "suppression",
  "enabled": true,
  "contextCharacteristics": [
    {
      "kind": "Condition",
      "eventTimeRepresentation": "investigationTime",
      "allowableValues": [false, true],
      "defaultValue": false,
      "proxyKind": "selected"
    },
    {
      "kind": "Capsule",
      "eventTimeRepresentation": "investigationTime",
      "allowableValues": [false, true],
      "defaultValue": false,
      "proxyKind": "selected"
    },
    {
      "kind": "Asset",
      "eventTimeRepresentation": "investigationTime",
      "allowableValues": [false, true],
      "defaultValue": false,
      "proxyKind": "selected"
    }
  ],
  "uiConfig": {
    "iconRepresentation": {
      "onClickAction": "toggleState",
      "defaultRepresentation": false,
      "discreteStates": [
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.SUPPRESSION.UNSUPPRESS",
          "value": true,
          "icon": "svgpath:M 0 0.891 C 0 0.397 0.529 0 1.188 0 L 17.813 0 C 18.471 0 19 0.397 19 0.891 C 19 1.384 18.471 1.781 17.813 1.781 L 17.417 1.781 L 17.417 2.486 C 17.417 3.982 16.625 5.418 15.215 6.476 L 11.177 9.5 L 15.21 12.524 C 16.625 13.582 17.417 15.018 17.417 16.514 L 17.417 17.219 L 17.813 17.219 C 18.471 17.219 19 17.616 19 18.109 C 19 18.603 18.471 19 17.813 19 L 1.188 19 C 0.529 19 0 18.603 0 18.109 C 0 17.616 0.529 17.219 1.188 17.219 L 1.583 17.219 L 1.583 16.514 C 1.583 15.018 2.375 13.582 3.785 12.524 L 7.823 9.5 L 3.785 6.476 C 2.375 5.418 1.583 3.982 1.583 2.486 L 1.583 1.781 L 1.188 1.781 C 0.529 1.781 0 1.384 0 0.891 Z M 5.467 13.786 C 5.274 13.931 5.096 14.087 4.938 14.25 L 14.062 14.25 C 13.904 14.087 13.726 13.931 13.533 13.786 L 9.5 10.758 L 5.467 13.782 L 5.467 13.786 Z M 14.062 4.75 C 14.695 4.097 15.042 3.303 15.042 2.486 L 15.042 1.781 L 3.958 1.781 L 3.958 2.486 C 3.958 3.306 4.305 4.097 4.938 4.75 L 14.062 4.75 Z",
          "nextToggleValue": false,
          "tooltipTemplate": "${payload.contextToolTip}"
        },
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.SUPPRESSION.SUPPRESS",
          "value": false,
          "icon": "svgpath:M 0 0.891 C 0 0.397 0.529 0 1.188 0 L 17.813 0 C 18.471 0 19 0.397 19 0.891 C 19 1.384 18.471 1.781 17.813 1.781 L 17.417 1.781 L 17.417 2.486 C 17.417 3.982 16.625 5.418 15.215 6.476 L 11.177 9.5 L 15.21 12.524 C 16.625 13.582 17.417 15.018 17.417 16.514 L 17.417 17.219 L 17.813 17.219 C 18.471 17.219 19 17.616 19 18.109 C 19 18.603 18.471 19 17.813 19 L 1.188 19 C 0.529 19 0 18.603 0 18.109 C 0 17.616 0.529 17.219 1.188 17.219 L 1.583 17.219 L 1.583 16.514 C 1.583 15.018 2.375 13.582 3.785 12.524 L 7.823 9.5 L 3.785 6.476 C 2.375 5.418 1.583 3.982 1.583 2.486 L 1.583 1.781 L 1.188 1.781 C 0.529 1.781 0 1.384 0 0.891 Z M 5.467 13.786 C 5.274 13.931 5.096 14.087 4.938 14.25 L 14.062 14.25 C 13.904 14.087 13.726 13.931 13.533 13.786 L 9.5 10.758 L 5.467 13.782 L 5.467 13.786 Z M 14.062 4.75 C 14.695 4.097 15.042 3.303 15.042 2.486 L 15.042 1.781 L 3.958 1.781 L 3.958 2.486 C 3.958 3.306 4.305 4.097 4.938 4.75 L 14.062 4.75 Z",
          "iconFill": "white",
          "nextToggleValue": true,
          "tooltipTemplate": "${payload.contextToolTip}"
        }
      ],
      "mixedStates": {
        "icon": "svgpath:M 0 0.891 C 0 0.397 0.529 0 1.188 0 L 17.813 0 C 18.471 0 19 0.397 19 0.891 C 19 1.384 18.471 1.781 17.813 1.781 L 17.417 1.781 L 17.417 2.486 C 17.417 3.982 16.625 5.418 15.215 6.476 L 11.177 9.5 L 15.21 12.524 C 16.625 13.582 17.417 15.018 17.417 16.514 L 17.417 17.219 L 17.813 17.219 C 18.471 17.219 19 17.616 19 18.109 C 19 18.603 18.471 19 17.813 19 L 1.188 19 C 0.529 19 0 18.603 0 18.109 C 0 17.616 0.529 17.219 1.188 17.219 L 1.583 17.219 L 1.583 16.514 C 1.583 15.018 2.375 13.582 3.785 12.524 L 7.823 9.5 L 3.785 6.476 C 2.375 5.418 1.583 3.982 1.583 2.486 L 1.583 1.781 L 1.188 1.781 C 0.529 1.781 0 1.384 0 0.891 Z M 5.467 13.786 C 5.274 13.931 5.096 14.087 4.938 14.25 L 14.062 14.25 C 13.904 14.087 13.726 13.931 13.533 13.786 L 9.5 10.758 L 5.467 13.782 L 5.467 13.786 Z M 14.062 4.75 C 14.695 4.097 15.042 3.303 15.042 2.486 L 15.042 1.781 L 3.958 1.781 L 3.958 2.486 C 3.958 3.306 4.305 4.097 4.938 4.75 L 14.062 4.75 Z",
        "nextToggleValue": false,
        "labelTranslationKey": "VANTAGE.EXTENSIONS.SUPPRESSION.SUPPRESS",
        "tooltipTemplate": "${payload}"
      }
    },
    "consoleToolbarConfiguration": {
      "sortOrder": 4,
      "componentUi": "Suppression",
      "onClick": "deferToComponentUI",
      "portal": "toolbar"
    }
  }
}
